var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#FED241"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 17.75C18.25 15.1266 20.3766 13 23 13C25.6234 13 27.75 15.1266 27.75 17.75V20.3122C27.2859 19.9691 26.7833 19.6751 26.25 19.4377V17.75C26.25 15.9551 24.7949 14.5 23 14.5C21.2051 14.5 19.75 15.9551 19.75 17.75V19.4377C19.2167 19.6751 18.7141 19.9691 18.25 20.3122V17.75Z",
    fill: "#FED241"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.25 21.1196C26.8077 21.4422 27.313 21.8452 27.75 22.3129C28.8356 23.4745 29.5 25.0347 29.5 26.75C29.5 30.3399 26.5899 33.25 23 33.25C19.4101 33.25 16.5 30.3399 16.5 26.75C16.5 25.0347 17.1644 23.4745 18.25 22.3129C18.687 21.8452 19.1923 21.4422 19.75 21.1196C20.7061 20.5665 21.8161 20.25 23 20.25C24.1839 20.25 25.2939 20.5665 26.25 21.1196ZM22.375 26.4167C22.375 26.0485 22.7108 25.75 23.125 25.75C23.5392 25.75 23.875 26.0485 23.875 26.4167V28.2833C23.875 28.6515 23.5392 28.95 23.125 28.95C22.7108 28.95 22.375 28.6515 22.375 28.2833V26.4167Z",
    fill: "#FED241"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.52fc9dc59ef710448c02221dee187634.svg";
export { ForwardRef as ReactComponent };